<div>
  <div mat-dialog-content class="text-center flex flex-column">
    <lum-ui-icon
      icon="alert-information-circle"
      color="#23491c"
      width="30"
      height="30"
    ></lum-ui-icon>
    <h3 class="my-3">Order Updated</h3>
    <div class="my-3">
      <p><span class="font-bold">Luminous: </span> {{ data?.luminous }}</p>
      <p> <span class="font-bold">Shipstation: </span> {{ data?.shipstation }} </p>
    </div>
    <button mat-button mat-dialog-close>OK</button>
  </div>
</div>
